import React from 'react';

import { Anchor, AnchorOwnProps } from '@ovpn-ui/core';

import { Wrapper } from './ReadMore.styles';

type Props = AnchorOwnProps & {
    link?: string;
    to?: string;
    text?: React.ReactNode;
    target?: string;
    onClick?: any;
    className?: string;
    id?: string;
};

export function ReadMore({
    to,
    link,
    text = 'Read more here',
    target = '_blank',
    className,
    ...rest
}: Props) {
    const isOpsPortal = window.location.hostname.startsWith('opsportal.');

    if (isOpsPortal) {
        return <span>{text}</span>;
    }

    const linkProp = to ? { to } : { href: link };

    return (
        <Wrapper className={className}>
            <Anchor external target={target || undefined} {...linkProp} {...rest}>
                {text}
            </Anchor>
        </Wrapper>
    );
}
